/**
 * Which environment is this build actually running in?
 *
 * Read from <meta name="app-env">, which the Express server stamps into every
 * served index.html (modules/seoMeta.js). import.meta.env.VITE_NODE_ENV cannot
 * answer this: vue-app/.env is committed with VITE_NODE_ENV=production, so a
 * build made on the dev box also reports "production" and would inject
 * renants.com SEO tags onto finoptima.tech.
 *
 * The tag is absent when the Vite dev server serves index.html itself, so the
 * fallback is "not production" — the safe answer.
 */

let cached: string | null = null

export function appEnv(): string {
  if (cached === null) {
    const tag = document.querySelector('meta[name="app-env"]')
    cached = (tag?.getAttribute('content') || 'unknown').toLowerCase()
  }
  return cached
}

/** True only on the real production host — gates all SEO tags and analytics. */
export function isSeoEnabled(): boolean {
  return appEnv() === 'production'
}
